// Best-effort "is this directory user a guest?" hint for a Microsoft Graph /users result.
// Used by the people picker to set the persona's `isGuest` flag, which drives suggestion
// ordering (guests sort last) and acts as an external-ness fallback when the tenant's
// verified domains are unavailable. NOTE: it is NOT what decides "existing guest vs new
// external invite" in the share panel — that decision is existence-based (the persona's
// `isDirectoryUser` flag), because every /users result already exists in the directory
// regardless of userType. This helper only labels the guest-ness of that existing user.
//
// Two independent signals are checked, because `userType` is NOT a reliable sole indicator:
//   1. userType === "Guest" — the documented value, but Microsoft only sets it "typically".
//      It can come back null (e.g. guests whose attribute was never stamped, or accounts
//      synced/created without it) or even "Member" for converted accounts.
//   2. The userPrincipalName carries the "#EXT#" marker — the structural, language- and
//      config-invariant signature of a B2B collaboration user object. A guest invited as
//      john@contoso.com into the fabrikam tenant has the UPN
//      "john_contoso.com#EXT#@fabrikam.onmicrosoft.com" (Microsoft Entra docs). This is the
//      canonical way Entra ID represents a guest, so it catches guests whose userType is missing
//      — which is exactly the case that was blocking an existing guest from being shared with.
//
// Either signal is sufficient; the "#EXT#" match is case-insensitive.
export const isExternalGuestUser = (user: { userType?: string; userPrincipalName?: string }): boolean => {
  if (!user) return false;
  if (user.userType === "Guest") return true;
  return (user.userPrincipalName ?? "").toLowerCase().includes("#ext#");
};
